import { render, staticRenderFns } from "./EstablishCollege.vue?vue&type=template&id=ca5ab730&scoped=true&"
import script from "./EstablishCollege.vue?vue&type=script&lang=js&"
export * from "./EstablishCollege.vue?vue&type=script&lang=js&"
import style0 from "./EstablishCollege.vue?vue&type=style&index=0&id=ca5ab730&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca5ab730",
  null
  
)

export default component.exports